
let targetTime = localStorage.getItem("targetTime");

if (!targetTime) {
  targetTime = new Date().getTime() + 15 * 60 * 1000;
  localStorage.setItem("targetTime", targetTime);
} else {
  targetTime = parseInt(targetTime);
}

setInterval(() => {
  const timerElement = document.getElementById("M-timer-time");

  // If cart re-rendered and element not found, just skip this tick
  if (!timerElement) return;

  const currentTime = new Date().getTime();
  let timeRemaining = targetTime - currentTime;

  if (timeRemaining <= 0) {
    targetTime = new Date().getTime() + 15 * 60 * 1000;
    localStorage.setItem("targetTime", targetTime);
    timeRemaining = targetTime - currentTime;
  }

  const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
  const seconds = Math.floor((timeRemaining / 1000) % 60);

  timerElement.textContent =
    `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

}, 1000);